<template>
  <router-view class="content" />
</template>


<script>
export default {
  name: "RouterViewContent",
}
</script>
